import React, { useState, useEffect } from 'react';
import './Integration.css';

interface IntegrationProps {
  onTryForFreeClick: () => void;
  onRequestDemoClick: () => void;
}

const Integration: React.FC<IntegrationProps> = ({ onTryForFreeClick, onRequestDemoClick }) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in commented-out integrations list
  const integrations = [
    { name: "MS Teams", logo: "/External Logo/MS Teams.png" },
    { name: "Slack", logo: "/External Logo/Slack.png" },
    { name: "Outlook", logo: "/External Logo/Outlook.png" },
    { name: "Onedrive", logo: "/External Logo/Onedrive.png" },
    { name: "Sharepoint", logo: "/External Logo/Sharepoint.png" },
    { name: "Google Drive", logo: "/External Logo/Google Drive.png" },
    { name: "LinkedIn", logo: "/External Logo/LinkedIn.png" },
    { name: "Pinterest", logo: "/External Logo/Pinterest.png" },
    { name: "Dezeen", logo: "/External Logo/Dezeen.png" },
    { name: "ArchDaily", logo: "/External Logo/ArchDaily.png" },
    { name: "RIBA", logo: "/External Logo/RIBA.png" },
    { name: "ARB", logo: "/External Logo/ARB.png" }
  ];

  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- used in commented-out integrations list
  const [isMobile, setIsMobile] = useState(false);

  // Check if we're on mobile - this needs to be fixed
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <section className="integration-section" id="integration">
      <div className="integration-container">
        <div className="integration-content">
          <h2 className="integration-title">
            Find anything with one search.
          </h2>
          <p className="integration-subtitle">
            Search across your selected practice knowledge and apps, right inside Archaas.
          </p>
          <div className="integration-actions">
            <button className="integration-btn-primary" onClick={onTryForFreeClick}>Watch Demo</button>
            <button className="integration-btn-secondary" onClick={onRequestDemoClick}>Live Demo →</button>
          </div>
          
          <p className="integrations-security-note">
            *Enterprise-grade security with encryption and compliance certifications; never trains on your data.
          </p>
          
          {/* TEMPORARILY DISABLED - Integrations list */}
          {/* <div className="integrations-section">
            <h3 className="integrations-title">Integrates with</h3>
            
            <div className={`integrations-grid ${isMobile ? 'mobile-hidden' : ''}`}>
              {integrations.map((integration, index) => (
                <div key={index} className="integration-item">
                  <img 
                    src={integration.logo} 
                    alt={integration.name} 
                    className="integration-icon"
                  />
                  <span>{integration.name}</span>
                </div>
              ))}
            </div>

            <div className={`integrations-mobile-grid ${!isMobile ? 'mobile-hidden' : ''}`}>
              {integrations.map((integration, index) => (
                <div key={index} className="mobile-integration-item">
                  <img 
                    src={integration.logo} 
                    alt={integration.name} 
                    className="integration-icon"
                  />
                  <span>{integration.name}</span>
                </div>
              ))}
            </div>
          </div> */}
        </div>
        
        <div className="integration-visual">
          <div className="integration-image-placeholder">
            <img 
              src="/Logo Wheel.png" 
              alt="Integration Wheel" 
              className="integration-wheel-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integration;